export default "__VITE_ASSET__Bt9kvn3h__"